/*
 * @Author: limingshuang limingshuang@yunhdkc.com
 * @Date: 2025-02-07 14:42:19
 * @LastEditors: limingshuang limingshuang@yunhdkc.com
 * @LastEditTime: 2025-02-08 17:12:08
 * @FilePath: \dyt_html_v2.0\src\apis\ask2Api\base.js
 * @Description: 在线问诊重构
 */
import axios from '../../library/modules/axios'
const service = axios.askServiceApi
export default service